"use strict";exports.u=t=>t.filter(t=>t.product?.sku).filter(t=>!1===t.isAvailable).length>0;